import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserService } from '../_services';
import * as UserActions from '../_actions/user';
import { AppState } from '../_reducers';
import { selectCurrentUser } from '../_selectors/currentUser.selectors';
import { updateCurrentUserSuccess } from '../_actions/currentUser';

@Injectable({
  providedIn: 'root',
})
export class UserEffects {
  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadUsers),
      mergeMap(() =>
        this.userService.getUsers().pipe(
          map((users) => UserActions.loadUsersSuccess({ users })),
          catchError((error) => of(UserActions.loadUsersFailure({ error })))
        )
      )
    )
  );

  addUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.addUser),
      mergeMap(({ user }) =>
        this.userService.saveUser(user).pipe(
          map((savedUser) => UserActions.addUserSuccess({ user: savedUser })),
          catchError((error) => of(UserActions.addUserFailure({ error })))
        )
      )
    )
  );

  updateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.updateUser),
      mergeMap(({ user }) =>
        this.userService.saveUser(user).pipe(
          map((updatedUser) => UserActions.updateUserSuccess({ user: updatedUser })),
          catchError((error) => of(UserActions.updateUserFailure({ error })))
        )
      )
    )
  );

  deleteUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.deleteUser),
      mergeMap(({ id }) =>
        this.userService.deleteUser(id).pipe(
          map(() => UserActions.deleteUserSuccess({ id })),
          catchError((error) => of(UserActions.deleteUserFailure({ error })))
        )
      )
    )
  );

  // Nuovo effetto per sincronizzare il currentUser
  syncCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.updateUserSuccess), // Intercetta l'azione updateUserSuccess
      withLatestFrom(this.store.select(selectCurrentUser)), // Ottieni l'utente corrente
      map(([action, currentUser]) => {
        if (currentUser?.id === action.user.id) {
          // Se l'utente aggiornato è il currentUser, dispatcha l'azione
          return updateCurrentUserSuccess({
            user: action.user,
          });
        }
        return { type: '[CurrentUser] No Action' }; // Nessuna azione se non è il currentUser
      })
    )
  );

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private store: Store<AppState>
  ) {}
}
